export const authTokenService = {
	saveToken: (token) => saveToken(token),
	clearSession: () => clearSession(),
	getToken: () => getToken(),
	getClaims: () => getClaims(),
	isInRole: (roles) => isInRole(roles),
	saveShouldChangePassword: (status) => sessionStorage.setItem('shouldChangePassword', status),
	getShouldChangePassword: () => getShouldChangePassword()
};

/**
 * Saves the auth token locally.
 * @param {string} token - The auth token to be stored.
 */
function saveToken (token) {
	sessionStorage.setItem('access_token', token);
}

/**
 * Clears all fields from local storage.
 */
function clearSession () {
	sessionStorage.clear();
}

/**
 * Gets the token from local storage.
 */
function getToken () {
	return sessionStorage.getItem('access_token');
}

/**
 * Returns the JWT claims
 */
function getClaims () {
	const token = getToken();
	if (token) {
		return JSON.parse(atob(token.split('.')[1])); // TODO - DD - Store this so we don't have to parse every time...
	}
	return {};
}

/**
 * Returns whether the user's role claim contains at least one of the roles passed in. Returns true if the parameter is null or an empty array.
 * @param {string[]} roles - The roles to check against the user role claims.
 */
function isInRole (roles) {
	// If no roles are configured then return true
	if (!roles || roles.length === 0) {
		return true;
	}

	// TODO - DD - look into caching this info
	const claims = getClaims();
	if (claims.roles && claims.roles.length > 0) {
		for (const userRole of claims.roles) {
			const found = roles.find(element => {
				return element.toLowerCase() === userRole.toLowerCase();
			});

			if (found) {
				return true;
			}
		}
	}
	return false;
}

/**
 * Gets the should change password status from local storage as a boolean type.
 * @returns {boolean} - Whether the user should change their password
 */
function getShouldChangePassword () {
	const shouldChangePassword = sessionStorage.getItem('shouldChangePassword');
	if (shouldChangePassword === null) {
		return null;
	} else {
		return shouldChangePassword === 'true';
	}
}
